import React, { useEffect, useState } from 'react'
import threadsService from '@/app-domains/threads/threads.service'
import { MenuBottom } from '../MenuBottom/MenuBottom'
import { BoxesButtons } from './components/BoxesButtons/BoxesButtons'
import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import EditSelectedBoxesModal from '../HomeMenu/components/EditSelectedBoxesModal/EditSelectedBoxesModal'
// import { SortMenu } from './components/SortMenu/SortMenu'
import { SortMenu } from '@/components/SortMenu/SortMenu'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import commonsService from '@/services/commons.service'
import store from '@/core/store'

import './BoxesMenu.scoped.sass'
import boxesService from '@/app-domains/boxes/boxes.service'

export function BoxesMenu () {
  const [selectedBox, setSelectedBox] = useState('')
  // eslint-disable-next-line
  const [lastRender, setLastRender] = useState(Date.now())
  const [selectedSortType, setSelectedSortType] = useState('Unread')
  const [sideMenuHidden, setSideMenuHidden] = useState(true)

  const hideSideMenu = () => {
    setSideMenuHidden(true)
  }
  /*
    Combination of useEffect + useRenderEvent needed since we are passing the
    state to other components and we need to access the actual state from and only from useEffect.
  */

  useRenderEvent(['CONTAINERS:UPDATED'], () => {
    setLastRender(Date.now())
  })

  useRenderEvent(['SIDE_MENU:HIDE'], () => {
    setSideMenuHidden(true)
  })

  useRenderEvent(['SIDE_MENU:SHOW'], () => {
    setSideMenuHidden(false)
  })

  useRenderEvent(['SELECTED_BOXES:UPDATED'], () => {
    setLastRender(Date.now())
  })

  useEffect(() => {
    setTimeout(() => commonsService.isMobile() && store.commit('SIDE_MENU:SHOW'), 50)
  }, [])

  const selectBox = (box) => {
    setSelectedBox(box.id)
    threadsService.applyFilterFor('Box', box.boxalias || box.boxname, box.composedid)
    setSideMenuHidden(true)
  }
  
  const selectSortType = (sortType) => {
    setSelectedSortType(sortType)
  }

  function getUserInfo () {
    const myInfo = store.getState().me.me
    return (
      <div className='user-info-container'>
        <div className='user-info-domain'>
          <span className='user-domain' title={myInfo.defaultdomain}>{myInfo.defaultdomain}</span>
        </div>
      </div>
    )
  }

  function getEditMultipleBoxesButton () {
    const selectedBoxes = boxesService.getSelectedBoxesFromStore()
    if (selectedBoxes === undefined || selectedBoxes.length === 0) {
      return (
        <></>
      )
    } else {
      return (
        <div className='edit-boxes-div'>
          <Button content={`Edit selected boxes (${selectedBoxes.length})`} click={() => modalService.open(<EditSelectedBoxesModal />)} />
        </div>
      )
    }
  }

  return (
    <div className='aside-content' id='home-menu'>
      <div className={`primary-menu ${sideMenuHidden ? 'hidden-menu' : 'mb-show-menu'}`}>
        <div className="primary-menu-container">
          { commonsService.isMobile() && getUserInfo() }
          <div className="menu-top-container">
            <section>
              <div className="menu-top">
                <div className="menu-top-label">
                  Boxes
                </div>
                <div className="menu-top-right">
                  <SortMenu sortValues={['Unread', 'A-Z', 'Created at', 'Updated at']} selectSortType={selectSortType} selectedSortType={selectedSortType} />
                </div>
              </div>
            </section>
            <section>
              { getEditMultipleBoxesButton() }
            </section>
          </div>
          
          <div className="menu-content">
            <ul className='scrollable-list boxes-buttons labels-group overflow-y-scroll'>
              <BoxesButtons selectedBox={selectedBox} selectBox={selectBox} selectedSortType={selectedSortType}/>
            </ul>
          </div>
        </div>
        { !commonsService.isMobile() && <MenuBottom /> }
      </div>
      
      <div className={`side-menu-backdrop ${sideMenuHidden ? 'hidden' : ''}`} onClick={hideSideMenu}></div>
    </div>

  )
}
